import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Checkbox,
  Input,
  Stack,
  FormHelperText,
  CheckboxGroup,
} from "@chakra-ui/react";
const CheckBox = ({ options, formik, id, optionslength }) => {
  let checkbox = formik.values.checkBox ? [...formik.values.checkBox] : [];
  let arr = [];
  const setValues = formik.setValues;
  const formikValues = formik.values;
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const checkBoxErrors =
    Object.keys(formik.errors).length &&
    formik.errors.checkBox &&
    formik.errors.checkBox.length &&
    formik.errors.checkBox[id];
  const checkBoxTouched =
    Object.keys(formik.touched).length &&
    formik.touched.checkBox &&
    formik.touched.checkBox.length &&
    formik.touched.checkBox[id];
  const hasError = checkBoxTouched && checkBoxErrors;

  const onChangecheckBox = (e, id) => {
    e.preventDefault();
    const currentValues = e.target.checked;
    checkbox.length &&
      Object.keys(formikValues.checkBox[id]).forEach((field, i) => {
        Object.keys(formikValues.checkBox[i])[0] == e.target.name &&
          (formikValues.checkBox[i][e.target.name] = currentValues);
      });
    setValues({ ...formikValues });
  };
  options.choices.map((element, index) => {
    if (
      formik.values.checkBox.length &&
      formik.values.checkBox.length <= options.choices.length &&
      index < options.choices.length
    ) {
      const value = {
        [element.name]: element.checked ? element.checked : false,
        mandatory: element.checked ? element.checked : false,
      };
      arr.splice(index, 0, value);
      checkbox[id] = arr;
    } else {
      const value = {
        [element.name]: element.checked ? element.checked : false,
        mandatory: element.checked ? element.checked : false,
      };

      arr.splice(index, 0, value);
      checkbox[id] = arr;
    }
    if (arr.length == options.choices.length) {
      formik.values.checkBox[id] = checkbox[id];
    }
    if (optionslength == id) {
      setValues({ ...formik.values.checkBox });
    }
  });
  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel fontSize="14px">{options.label}</FormLabel>
      )}
      <CheckboxGroup colorScheme="blue">
        <Stack spacing={[1, 2]} direction={["column"]}>
          {options.choices.map((element, index) => {
            return (
              <Checkbox
                id={element.id}
                key={element.name}
                name={element.name}
                isChecked={element.checked}
                onChange={(e) => {
                  !element.checked && onChangecheckBox(e, id);
                }}
                mt="3"
                fontSize="13px"
              >
                {" "}
                {element.name}
              </Checkbox>
            );
          })}
        </Stack>
      </CheckboxGroup>
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.checkBox}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default CheckBox;
